import { Severity } from "src/app/global/enums/severity";

export namespace NotificationsActions {
  export class Toast {
    static readonly type = `[Notifications] Toast`
    constructor(public message: string, public severity: Severity) {}
  }
}
